import * as Constants from '../../../constants';
import * as React from 'react';
import { useGlobalContext } from '../../context';
import useStyles from './UserDropdown.styles';

interface IUserDropdownProps {
  username: string;
  roles: string[];
}

const UserDropdown: React.FC<IUserDropdownProps> = ({ username, roles }) => {
  const classes = useStyles();
  const { appConfig } = useGlobalContext();
  const [isOpen, setIsOpen] = React.useState(false);

  const toggleDropdown = () => {
    setIsOpen(prevState => !prevState);
  };

  const handleLogoutClick = () => {
    window.location.href = appConfig.logoutUrl;
  };

  return (
    <div
      className={classes.userDropdownContainer}
      data-qa-name="menu"
      onClick={toggleDropdown}
    >
      <div className={classes.userInfo}>
        <span>
          {username} {isOpen ? '▲' : '▼'}
        </span>
        <span className={classes.roleText}>{roles}</span>
      </div>
      {isOpen && (
        <div className={classes.dropdownContent}>
          <div className={classes.logoutLink} onClick={handleLogoutClick}>
            {Constants.LOG_OUT}
          </div>
          <div className={classes.userManualLink}>
            <a
              href={Constants.USER_MANUAL_LINK}
              target="_blank"
              rel="noopener noreferrer"
            >
              {Constants.USER_MANUAL}
            </a>
          </div>
        </div>
      )}
    </div>
  );
};

export default UserDropdown;
